import { BehaviorSubject } from 'rxjs';

const defaultCriteria = {
  limit: 10,
  orderField: null,
  orderType: 'ASC',
  page: 0,
};

export default class AdminRepository {
  administrators$ = new BehaviorSubject([]);
  adminToInvite$ = new BehaviorSubject(null);
  searchCriteria$ = new BehaviorSubject(defaultCriteria);

  constructor({ adminService }) {
    this.adminService = adminService;
  }

  async getAdministrators(criteria, workspaceId) {
    const administrators = await this.adminService.getAdministrators(
      {
        ...this.searchCriteria$.getValue(),
        ...criteria,
      },
      workspaceId
    );
    this.administrators$.next(administrators);
  }

  async getActiveAdminInWorkspace() {
    return this.adminService.getActiveAdminInWorkspace();
  }

  reInviteAdmin(name, phoneNumber, email, id, workspaceId) {
    return this.adminService.reInviteAdmin(name, phoneNumber, email, id, workspaceId);
  }

  inviteAdmin(name, phoneNumber, email, workspaceId) {
    return this.adminService.inviteAdmin(name, phoneNumber, email, workspaceId);
  }

  resetSearchCriteria() {
    this.searchCriteria$.next(defaultCriteria);
  }

  updateSearchCriteria(criteria) {
    this.searchCriteria$.next({
      ...this.searchCriteria$.getValue(),
      ...criteria,
    });
  }

  disableAdmin(adminId) {
    return this.adminService.disableAdmin(adminId);
  }

  enableAdmin(adminId) {
    return this.adminService.enableAdmin(adminId);
  }
}
